import { Box, MenuItem, Typography } from '@mui/material';
import ButtonComponent from '../ButtonComponent';
import Menu from '@mui/material/Menu';
import { MouseEvent, ReactNode, useEffect, useState } from 'react';
import { Delete, Menu as MenuIcon, ModeEdit } from '@mui/icons-material';
import { t } from 'i18next';

export interface IActionButtonProps {
  label: string;
  icon: ReactNode;
  disabled?: boolean;
  onClick: () => void;
  isHidden?: boolean;
}

interface ButtonActionsComponentProps {
  isWithDefaultOptionsList?: boolean;
  handleEdit?: () => void;
  editButtonLabel?: string;
  handleDelete?: () => void;
  handleUpdateStatus?: () => void;
  actionOptions?: IActionButtonProps[];
}

const ButtonActionsComponent = ({
  isWithDefaultOptionsList,
  handleEdit,
  editButtonLabel,
  handleDelete,
  handleUpdateStatus,
  actionOptions,
}: ButtonActionsComponentProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const [options, setOptions] = useState<IActionButtonProps[]>([]);

  const handleClose = (event: any) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  const defaultOptions: IActionButtonProps[] = [
    {
      label: editButtonLabel ?? t('actionButtonComponent.edit'),
      icon: <ModeEdit fontSize="small" />,
      onClick: () => handleEdit && handleEdit(),
      isHidden: !handleEdit ? true : false,
    },
    {
      label: t('actionButtonComponent.delete'),
      icon: <Delete fontSize="small" />,
      onClick: () => handleDelete && handleDelete(),
      isHidden: !handleDelete ? true : false,
    },
  ];

  useEffect(() => {
    const menuOptions: IActionButtonProps[] = [];
    if (isWithDefaultOptionsList) menuOptions.push(...defaultOptions);
    if (actionOptions) menuOptions.push(...actionOptions);
    setOptions(menuOptions);
  }, []);

  return (
    <Box>
      <ButtonComponent
        // id="basic-button"
        // aria-controls={open ? 'basic-menu' : undefined}
        // aria-haspopup="true"
        size="small"
        variant="outlined"
        // aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <MenuIcon />
      </ButtonComponent>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={(event) => handleClose(event)}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {options.map((option, index) =>
          !option.isHidden ? (
            <MenuItem
              key={index}
              sx={{ backgroundColor: '#4b4b4b' }}
              disabled={option.disabled}
              onClick={(event) => {
                event.stopPropagation();
                setAnchorEl(null);
                option.onClick();
              }}
            >
              <Typography sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                {option.icon}
              </Typography>
              {option.label}
            </MenuItem>
          ) : (
            <></>
          ),
        )}
      </Menu>
    </Box>
  );
};

export default ButtonActionsComponent;
